import { motion } from 'framer-motion';
import { SeasonBadge } from '../components/SeasonBadge';
import BlogCard, { blogPosts } from '../components/BlogCard';

const Blog = () => {
  const featuredPost = blogPosts[0];
  const otherPosts = blogPosts.slice(1);

  return (
    <div className="min-h-screen bg-[#F5F0EB]">
      {/* Hero Section */}
      <section className="bg-navy py-16">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center"
          >
            <div className="flex flex-wrap justify-center gap-3 mb-6">
              <SeasonBadge season="winter" className="px-4 py-2 text-sm" />
              <SeasonBadge season="fall" className="px-4 py-2 text-sm" />
            </div>
            <h1 className="font-oswald text-4xl md:text-5xl font-bold text-white mb-4">
              Expert Tips & Guides
            </h1>
            <p className="text-gray-300 text-lg max-w-2xl mx-auto">
              Stay informed with our latest articles on plumbing, heating, and home maintenance for Minnesota homeowners.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Featured Post */}
      <section className="py-12">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="font-oswald text-2xl font-bold text-[#14366C] mb-6">Featured Article</h2>
            <BlogCard post={featuredPost} featured={true} />
          </motion.div>
        </div>
      </section>

      {/* Other Posts */}
      <section className="py-12 bg-white">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="font-oswald text-2xl font-bold text-[#14366C] mb-6">More Articles</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {otherPosts.map((post, index) => (
                <motion.div
                  key={post.id}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 }}
                >
                  <BlogCard post={post} />
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-[#14366C]">
        <div className="container mx-auto px-4 text-center">
          <h2 className="font-oswald text-3xl font-bold text-white mb-4">
            Ready to Prepare Your Home for Winter?
          </h2>
          <p className="text-gray-300 mb-8 max-w-2xl mx-auto">
            Don't wait until the first freeze! Schedule your fall maintenance appointment today.
          </p>
          <a 
            href="tel:651-738-9354"
            className="inline-flex items-center bg-[#F58220] hover:bg-[#e07010] text-white font-oswald font-bold uppercase tracking-wider px-8 py-4 rounded-md transition-colors"
          >
            Call 651-738-9354
          </a>
        </div>
      </section>
    </div>
  );
};

export default Blog;
